import { CommonModule, LocationStrategy } from "@angular/common";
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { Enum } from "../helpers/enums/enum";
import { CommunicationService } from "../services/communication.service";
import { HttpErrorResponse } from "@angular/common/http";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { SeamlessHeaderComponent } from "../shared/seamless-header.component";
import { UserService } from "../services/user.service";

@Component({
  selector: 'app-reduce-debt',
  templateUrl: './reduce-debt.component.html',
  styleUrls: ['./reduce-debt.component.css'],
  standalone: true,
  imports: [CommonModule, SeamlessHeaderComponent, RouterModule],
})
export class ReduceDebtComponent implements OnInit {
  @ViewChild('DCCallbackConfirmationModel', { static: false }) DCCallbackConfirmationModel: ElementRef;
  @ViewChild('callbackSuccessModel', { static: false }) callbackSuccessModel: ElementRef;
  @ViewChild('callbackStatusModel', { static: false }) callbackStatusModel: ElementRef;

  allowNavigation = false;
  username: string = '';
  userName = "";
  modalOptions: NgbModalOptions;
  moved = false;
  displayDbQuoteSection = false;
  callbackErrorMsg = '';
  callbackSuccessMsg = '';
  monthlyInstalment;
  dbc_Dcrs ;
  setPosition=false;
  dcData:any;
  constructor(private router: Router, private modalService: NgbModal, private userService: UserService, private communicationService: CommunicationService,    private el: ElementRef, private renderer: Renderer2) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      keyboard: false
    };
    
  }


  ngOnInit() {
    this.DcAutoInsert();
    localStorage.setItem('PageUrls', 'onboarding');
    let userDataStr = localStorage.getItem('apiUserModel');
    let userData = userDataStr ? JSON.parse(userDataStr) : null;
    this.userName = userData?.given_name;

    this.monthlyInstalment=this.dcData ? this.dcData?.monthlyInstallment : null;
    this.dbc_Dcrs=this.dcData ? this.dcData?.dbC_DCRS : null;
    setTimeout(() => {
      this.moved = true;
    }, 2000);
    setTimeout(() => {
      this.displayDbQuoteSection = true;
      this.setPosition = true;
      this.renderer.addClass(this.el.nativeElement, 'bg-active');
    }, 2500);
  }


  DBLeadInsert(campaignSource: string) {

    const param = { CampaignSource: campaignSource, Referrer: 'Justmoney', WebSource: 'CreditSav_Solution', SessionId: sessionStorage.getItem('sessionId') };
    this.idmLeadInsert(param, false);

  }

closePopup(){
  this.modalService.dismissAll();
  this.callbackErrorMsg = '';
  this.callbackSuccessMsg = '';
  this.router.navigate(['/ready']);
}

  idmLeadInsert(param?: any, RequestFromBanner?: boolean) {
    this.callbackErrorMsg = '';
    this.callbackSuccessMsg = '';
    this.communicationService.leadCallbackSource(param).subscribe({
        next: (data: any) => {
      this.callbackSuccessMsg = 'DebtBusters expert will call them back soon';
      this.modalService.dismissAll();
      if (!RequestFromBanner) {
        this.modalService.open(this.callbackStatusModel, this.modalOptions);
      }
      
    }, error: (err: HttpErrorResponse) => {
      this.callbackErrorMsg = 'Something went wrong. Please try again later';
      this.modalService.open(this.callbackStatusModel, this.modalOptions);
    }});
  }
  SkipCallback(){
    this.router.navigate(['/ready']);
  }
  cleanupStorage() {
    localStorage.removeItem('OnLoadCheck');
  }
  allowUserNavigation() {
    this.allowNavigation = true;
  }
 DcAutoInsert(){
    this.userService.getDebtConsolidation().subscribe({
    next: (data: any) => {
    this.dcData=data;
    sessionStorage.setItem('loadUserType', JSON.stringify(this.dcData));
    this.communicationService.IDMLeadautoInsert().subscribe({
        next: (data: any) => {
      sessionStorage.setItem('isAutoInserted', 'true');
    }});
    }});
 }
}